import React from "react";
import Artworklist from "../helpers/Artworklist";
import Artworks from "../components/Artworks";
import "../styles/gallery.css";
function Gallery() {
  return (
    <div className="gallery" >
      
     <h1 className="heading">  Pushpit Gill Art Works</h1>
     <div className="artworklist">
        {Artworklist.map((menuItem, key) => {
          return (
            <Artworks
              key={key}
              image={menuItem.image}
             
              
            />
          );
        })}
      </div>
   
      
    </div>
  );
}

export default Gallery;
